<template>
  <vs-button :label="getJobNumber" type="tertiary" @click.stop="pushSearchJobRoute" />
</template>

<script>
import { getJobSearchRouteContext } from '@/common/useJobSearchRouteContext'

export default {
  name: 'JobCell',
  props: {
    jobNumber: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    getJobNumber() {
      return this.jobNumber.toString()
    },
  },

  methods: {
    async pushSearchJobRoute() {
      const { detailRouteName } = getJobSearchRouteContext()

      await this.$router.push({
        name: detailRouteName,
        params: {
          id: this.jobNumber,
        },
      })
    },
  },
}
</script>
